import styled from "styled-components";
import LOGO_BLACK_SVG from "../../images/logo.svg"
import CANCEL_SVG from "../../images/cancel.svg";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function MobileHeaderContentView({isOpen, onCancelClickHandler}){
    const uid = sessionStorage.getItem("uid");
    const navigate = useNavigate()
    const onItemClickHandler = (link) => {
        navigate(link); 
        onCancelClickHandler();
    }
    useEffect(() => {
        if (isOpen) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'auto';
        }
    
        // 컴포넌트가 언마운트되거나 모달이 닫힐 때 스크롤을 다시 허용
        return () => {
          document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    if(!isOpen){
        return null;
    }
    
    return(
        <Container>
            <div className="inner">
                <Header>
                    <Logo src={LOGO_BLACK_SVG} alt="logo_black" onClick={() => navigate("/")}/>
                    <ButtonMenu src={CANCEL_SVG} alt="cancel" onClick={onCancelClickHandler}/>
                </Header>
                <Contents>
                    <Item onClick={() => onItemClickHandler("/")}>서비스 소개</Item>
                    <Item onClick={() => onItemClickHandler("/instructor")}>강사 소개</Item>
                    <Item onClick={() => onItemClickHandler("/board")}>Q&A</Item>
                    <Item onClick={() => {onItemClickHandler(uid ? "/profile" : "/login")}}>{uid ? "프로필" : "로그인"}</Item>
                    <Item onClick={() => onItemClickHandler(uid ?  "/cart" : "/register")}>{uid ? "장바구니" : "회원가입"}</Item>
                </Contents>
            </div>
        </Container>
    )
}

const Container = styled.div`
    background-color: #FFF;
    z-index: 3;
    position: absolute;
    width: 100vw;
    height: 100vh;
    .inner{
        display: flex;
        flex-direction: column;
        gap: 48px;
    }
    animation: slideIn 1s forwards;
`

const Header = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-top: 12px;
    padding-bottom: 12px;
`

const Logo = styled.img`
    width: 120px;
`

const ButtonMenu = styled.img`
`

const Contents = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 16px;
`

const Item = styled.span`
    color: #555;
    font-size: 20px;
    font-weight: 400;
`

export default MobileHeaderContentView;